import React from 'react';

const ReviewSnippet = () => {
  const organizationJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    url: 'https://buddieshr.com/',
    logo: 'https://buddieshr.com/img/logo/logo_150.png',
    name: 'BuddiesHR',
    description: 'The #1 Employee Engagement Software in Slack',
    email: 'contact@buddieshr.com',
    address: {
      '@type': 'PostalAddress',
      streetAddress: '102 AVENUE DES CHAMPS ELYSEES',
      addressLocality: 'Paris',
      addressCountry: 'FR',
      addressRegion: 'Ile-de-France',
      postalCode: '75008',
    },
    vatID: 'FR30838465581',
  };

  const softwareJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'SoftwareApplication',
    name: 'BuddiesHR',
    operatingSystem: 'SLACK',
    applicationCategory: 'BusinessApplication',
    aggregateRating: {
      '@type': 'AggregateRating',
      ratingValue: 4.8,
      ratingCount: 262,
    },
    offers: {
      '@type': 'Offer',
      price: 0.8,
      priceCurrency: 'USD',
    },
  };
  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(organizationJsonLd) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(softwareJsonLd) }}
      />
    </>
  );
};

export default ReviewSnippet;
